import { SpinResponse } from '@cgs/data-access';
import { Game112ExtendedGameStateMachine, StopToRegularSpin } from '@cgs/machines';

export class CorsicaGameStateMachine extends Game112ExtendedGameStateMachine<SpinResponse> {
  protected override createRules(): void {
    super.createRules();

    // The base machine routes plain base-game spins straight from animation to
    // regularSpins, so the only win line presentation lives in the regularSpins
    // loop — which is suppressed during SDK autoplay. Route them through
    // shortWinLines instead (its animation is awaited by the flow), the same
    // way WorldChampionsGameStateMachine does. appendRule puts the rule first,
    // overriding the animation → regularSpins fallthrough for these spins.
    this.appendRule(
      this.animation,
      this.shortWinLines,
      (s, r) => new StopToRegularSpin<SpinResponse>(s, r)
    );
  }
}
